import { useState, forwardRef } from 'react';
import { Modal, Input } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { ReactComponent as Basket } from 'Assets/controls/basket.svg';
import { useAppDispatch } from 'Redux/store';
import { resetChatMessages } from "Redux/Chat/slice";
import styles from './OptionsMenu.module.scss';
import legacyStyles from 'Containers/Chat/Legacy.module.scss';

type OptionsMenuParams = {
  id: number;
  itemClickHandler: () => void;
};

export const OptionsMenu = forwardRef<HTMLDivElement, OptionsMenuParams>(
  ({ id, itemClickHandler: hideMenu }, ref) => {
    const [detailInfoModalIsOpen, setDetailInfoModalIsOpen] = useState(false);
    const dispatch = useAppDispatch();

    return (
      <div className={styles.optionsMenu} ref={ref}>
        <div
          className={styles.optionsMenu__item}
          onClick={() => {
            setDetailInfoModalIsOpen(true);
          }}
        >
          <span>Detail Info</span>
          <InfoCircleFilled className={styles.optionsMenu__item__icon} />
        </div>
        <hr className={styles.optionsMenu__line} />
        <div
          className={styles.optionsMenu__item}
          onClick={() => {
            dispatch(resetChatMessages());
            hideMenu();
          }}
        >
          <span>Clear chat</span>
          <Basket className={styles.optionsMenu__item__icon} />
        </div>

        <Modal
          className={legacyStyles.detailInfoModal}
          open={detailInfoModalIsOpen}
          footer={null}
          title={<p className={legacyStyles.detailTitle}>Detail Info</p>}
          closable={true}
          maskClosable={true}
          onCancel={() => setDetailInfoModalIsOpen(false)}
          width={400}
        >
          <label htmlFor="name">Name</label>
          <Input
            placeholder="010 ALISHER KUDRATOV"
            className={legacyStyles.nameInput}
          />

          <label htmlFor="phone-number">Phone Number</label>
          <Input placeholder="+123 222 222 22" />
        </Modal>
      </div>
    );
  },
);
